<template>
  <div class="yxtbiz-ai-robot__input-magic">
    <div class="yxtbiz-ai-robot__input-magic__wrap">
      <yxt-tooltip :content="$t('biz_ai_switchdisabled')"
                   placement="top"
                   :disabled="!isWaitAnswer">
        <div class="yxtbiz-ai-robot__input-magic--common hand" :class="{'is-selected': selected === 0, 'no-allow opacity6': isWaitAnswer}" @click="changeAskType(0)">
          <yxt-svg
            :remote-url="`${$staticBaseUrl}ufd/55a3e0/assistent/pc/svg/`"
            :width="16"
            :height="16"
            :icon-class="selected === 0 ? 'ai_answer' : 'ai_answer_gray'" />
          <span class="ml4">{{$t('pc_ass_knowledgeanswer'/** 知识问答 */)}}</span>
        </div>
      </yxt-tooltip>
      <yxt-tooltip :content="$t('biz_ai_switchdisabled')"
                   placement="top"
                   :disabled="!isWaitAnswer">
        <div class="yxtbiz-ai-robot__input-magic--common ml12 hand" :class="{'is-selected': selected === 1, 'no-allow opacity6': isWaitAnswer}" @click="changeAskType(1)">
          <yxt-svg
            :remote-url="`${$staticBaseUrl}ufd/55a3e0/assistent/pc/svg/`"
            :width="16"
            :height="16"
            :icon-class="selected === 1 ? 'ai_instruct' : 'ai_instruct_gray'" />
          <span class="ml4">{{$t('pc_ass_taskinstruct'/** 任务助手 */)}}</span>
        </div>
      </yxt-tooltip>
      
      <div class="flex-1"></div>
      <yxt-tooltip :content="$t('biz_ai_switchdisabled')"
                   placement="top"
                   :disabled="!isWaitAnswer">
                   <div class="yxtbiz-ai-robot__input-magic--common hand" @click="handleOpenTreasure" :class="{'no-allow opacity6': isWaitAnswer}">
                    <yxt-svg
                      :remote-url="`${$staticBaseUrl}ufd/55a3e0/assistent/pc/svg/`"
                      :width="16"
                      :height="16"
                      icon-class="treasure_gray" />
                    <span class="ml4">{{$t('pc_biz_lbl_treasure_chest'/** 任务助手 */)}}</span>
                  </div>
                  </yxt-tooltip>
      <yxt-dropdown ref="dropRefs" 
                  custom-elm
                  :loading="loading"
                  placement="top-start"
                  trigger="click"
                  @visible-change="visibleChange"
                  @command="handleCommand">
        <div class="is-magic-dropdown"></div>
        <yxt-dropdown-menu slot="dropdown" class="yxtbiz-ai-robot__input-dropdown" :class="{'yxtbiz-ai-robot__input-dropdown--large': isFullScreen}">
          <yxt-empty v-if="!info.length">
            <div slot="image" class="yxtbiz-ai-robot__input-dropdown--empty"><img  :src="$staticBaseUrl + '/ufd/55a3e0/img/ai-empty-app.jpg'" /></div>
            <div slot="text" class="mt12">{{$t('pc_biz_msg_empty_common_app').d('暂无常用应用')}}<p>{{$t('pc_biz_msg_empty_common_app1').d('可前往百宝箱添加')}}</p></div>
          </yxt-empty>
          <yxt-dropdown-item v-else :command='item' v-for="item in info" :key="item.id">
            <yxt-image :src="item.icon || ($staticBaseUrl + 'ufd/55a3e0/ai-select.png')" class="yxtbiz-ai-robot__wrap--img"></yxt-image><span class="text-26 font-size-16 v-mid">
              {{ item.appName }}</span>
          </yxt-dropdown-item>
        </yxt-dropdown-menu>    
      </yxt-dropdown>
    </div>
  </div>
</template>

<script>
import { ASK_TYPE } from '../const';
import { postTreasureList } from '../service';

export default {
  name: 'InputMagic',
  inject: ['getIsWaitAnswer', 'getClient', 'getFullscreen'],
  data() {
    this.svgRemoteUrl = this.$staticBaseUrl + 'ufd/55a3e0';
    return {
      info: [],
      loading: false,
      selected: ASK_TYPE.KNOWLEDGE
    };
  },
  computed: {
    isWaitAnswer() {
      return this.getIsWaitAnswer();
    },
    isFullScreen() {
      return this.getFullscreen();
    }
  },
  created() {
    this.$root.$on('HANDLE_CLICK_TREASURE_ITEM', this.handleOperation);
  },
  beforeDestroy() {
    this.$root.$off('HANDLE_CLICK_TREASURE_ITEM', this.handleOperation);
  },
  methods: {
    show() {
      this.$refs.dropRefs.show();
    },
    changeAskType(type) {
      if (this.isWaitAnswer) return;
      this.selected = type;
      this.$root.$emit('ASK_TYPE_CHANGE', type);
    },
    handleCommand(item) {
      if (this.isWaitAnswer) return this.$message.warning(this.$t('biz_ai_switchdisabled'));
      this.selected = item.categoryCode === 'kng' ? ASK_TYPE.KNOWLEDGE : ASK_TYPE.INSTRUCT;
      this.$root.$emit('TREASURE_HANDLE', item);
    },
    handleOperation(item) {
      if (this.isWaitAnswer) return this.$message.warning(this.$t('biz_ai_switchdisabled'));
      this.selected = item.categoryCode === 'kng' ? ASK_TYPE.KNOWLEDGE : ASK_TYPE.INSTRUCT;
      this.$emit('change', {
        showType: 'treasure',
        ...item
      });
    },
    visibleChange(v) {
      if (v) {
        this.getShortcutInfo();
      }
    },
    getShortcutInfo() {
      this.loading = true;
      postTreasureList({type: 1, clientType: this.getClient()}).then(res=>{
        this.info = [];
        if (res && res.length) {
          res.forEach(item=>{
            (item.appBeanList || []).filter(sItem=>{
              if (sItem.categoryId === '0' || sItem.permission) {
                this.info.push({
                  categoryCode: item.categoryCode,
                  ...sItem
                });
              }
            });
          });
        }
      }).finally(()=>{
        this.loading = false;
      });
    },
    handleOpenTreasure() {
      if (this.isWaitAnswer) return;
      this.$root.$emit('SHOW_TREASURE');
      // this.visible = !this.visible;
    }
  }
};
</script>
<style scoped>
.yxtbiz-ai-robot__wrap--img {
  width: 16px; 
  height: 16px;
  vertical-align: middle;
  margin-right: 8px;
  padding: 6px;
  background: #F4F5F6;
  border-radius: 4px;
}
</style>